module.exports = __webpack_public_path__ + "static/13-9fdd6b04a08521b51aada722b00d5b49.png";